import { Component } from "react"

/* Components */
import { Input } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { filters, player as findPlayer, create } from "../../api/Booking"

/* Helpers */
import { utils } from "../../helpers"

/* Timezone — окно брони набирается в ВЫБРАННОЙ зоне, а не в зоне машины */
import { nowInTz, currentOffsetHours, offsetLabel, wallToUtc } from "../../helpers/timezone"

/* Icons */
import { CloseIcon, CheckIcon, InfoIcon, CalendarIcon, ClockIcon, PlayerIcon, TableIcon, OperatorIcon, VipIcon, CommentIcon, PlusIcon } from "./BookingIcons"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* Moment */
import moment from "moment"

/* DatePicker Settings */
registerLocale("ru", ru)


/* THE INNER SEARCH APPEARS ONLY WHEN THE LIST OF GAMES IS LONG ENOUGH TO SCROLL */
const SEARCHABLE = 8

/* DELAY BEFORE THE ID OF THE PLAYER IS LOOKED UP */
const DELAY = 500

/* THE SHORTEST ID WORTH LOOKING UP */
const MIN_LENGTH = 2

/* STEP OF THE TIME PICKER, IN MINUTES */
const STEP = 15

/* READY MADE LENGTHS OF A WINDOW, IN MINUTES */
const LENGTHS = [60, 120, 180, 240]

/* EMPTY FORM STATE */
const EMPTY = {
    status: "loading",
    operators: [],
    tables: [],
    operatorID: 0,
    tableID: 0,
    player: "",
    start: null,
    end: null,
    comment: "",
    search: "",
    found: null,
    checking: false,
    waiting: false,
}


/* THE WALL CLOCK OF THE SELECTED TIMEZONE AS A LOCAL DATE
 *
 * The picker knows nothing about the timezone of the panel: it draws and returns plain local dates. The value
 * is sent back as the naked "YYYY-MM-DD HH:mm:ss" the admin really typed, and the backend reads it in the
 * selected zone — so every preset has to carry the numbers of that very zone, not the ones of the machine */
const wallNow = () => moment(nowInTz().format("YYYY-MM-DD HH:mm:ss"), "YYYY-MM-DD HH:mm:ss")


/* Widget Booking Form */
class BookingForm extends Component {

    constructor() {
        super()
        this.state = { visible: false, ...EMPTY }
    }

    componentWillUnmount = () => {
        clearTimeout(this._timer)
    }

    /* Open Action */
    open = () => {

        this.setState({ visible: true, ...EMPTY }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        clearTimeout(this._timer)
        this.setState({ visible: false, ...EMPTY })
    }

    /* Load Action — the operators and the VIP games come strictly inside the scope of the token */
    load = () => {

        /* Set Status */
        this.setState({ status: "loading" })

        /* Send to REST API */
        filters().then((response) => {
            if (response.status === 200) {

                /* Fields */
                const operators = response.data.operators ? response.data.operators : []
                const tables = response.data.tables ? response.data.tables : []

                /* A single operator needs no choosing, the window starts at the next quarter of an hour */
                this.setState({
                    status: "ok",
                    operators,
                    tables,
                    operatorID: operators.length === 1 ? parseInt(operators[0].id) : 0,
                    start: wallNow().add(STEP - (wallNow().minutes() % STEP), "minutes").seconds(0).toDate(),
                    end: wallNow().add(STEP - (wallNow().minutes() % STEP) + 60, "minutes").seconds(0).toDate(),
                })

            }
            else {
                this.setState({ status: "error" })
                Swal.fire(utils.notification(this.message(response), "error"))
                this.close()
            }
        }).catch(() => {
            this.setState({ status: "error" })
            Swal.fire(utils.notification(t("swal.generic"), "error"))
            this.close()
        })

    }

    /* Read The Error Message Of A Response */
    message = (response) => {

        if (response && response.data && response.data.message) {
            return response.data.message
        }

        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        return t("swal.generic")
    }

    /* Games Of The Selected Operator — a table the operator is not connected to never accepts its players,
     * and a table that is connected to nobody at all is simply not configured yet, so it stays in the list */
    getTables = () => {

        /* Fields */
        const { tables, operatorID, search } = this.state

        /* Fields */
        const value = search.trim().toLowerCase()

        /* Operator */
        const list = operatorID
            ? tables.filter((item) => !item.hasLinks || (item.operatorIDs || []).some((id) => parseInt(id) === parseInt(operatorID)))
            : tables

        /* Check Search */
        if (value === "") {
            return list
        }

        /* Send Result */
        return list.filter((item) => {

            const name = String(utils.checkValue(item.name, "")).toLowerCase()
            const slug = String(utils.checkValue(item.slug, "")).toLowerCase()
            const studio = String(utils.checkValue(item.studioName, "")).toLowerCase()

            return name.includes(value) || slug.includes(value) || studio.includes(value)
        })
    }

    /* Change Operator — the game of the previous operator is dropped, the player is looked up again */
    changeOperator = (id) => {

        /* Fields */
        const { operatorID } = this.state
        const value = parseInt(id)

        /* Check Selection */
        if (parseInt(operatorID) === value) {
            return
        }

        this.setState({ operatorID: value, tableID: 0, search: "" }, () => this.check())
    }

    /* Change Player — the id is looked up only after the typing stops */
    changePlayer = (player) => {

        this.setState({ player, found: null })

        clearTimeout(this._timer)
        this._timer = setTimeout(() => this.check(), DELAY)
    }

    /* Check Player — who stands behind the id, so the form never books a table for a typo */
    check = () => {

        /* Fields */
        const { player, operatorID } = this.state
        const value = String(player).trim()

        /* Check Value */
        if (value.length < MIN_LENGTH) {
            this.setState({ found: null, checking: false })
            return
        }

        /* Start Checking */
        this.setState({ checking: true })

        /* Send to REST API */
        findPlayer({ player: value, operatorID: operatorID ? operatorID : "" }).then((response) => {
            if (response.status === 200) {
                this.setState({ found: response.data })
            }
            else {
                this.setState({ found: null })
            }
        }).catch(() => {
            this.setState({ found: null })
        }).finally(() => {
            this.setState({ checking: false })
        })

    }

    /* Change Start — the end follows the start and keeps the length of the window */
    changeStart = (date) => {

        /* Fields */
        const { start, end } = this.state

        /* Check Value */
        if (!date) {
            this.setState({ start: null })
            return
        }

        /* Length Of The Window — an untouched end simply moves along */
        const length = start && end ? moment(end).diff(moment(start), "minutes") : 60

        this.setState({ start: date, end: moment(date).add(length > 0 ? length : 60, "minutes").toDate() })
    }

    /* Set The Length Of The Window */
    setLength = (minutes) => {

        /* Fields */
        const { start } = this.state
        const from = start ? moment(start) : wallNow()

        this.setState({ start: from.toDate(), end: from.clone().add(minutes, "minutes").toDate() })
    }

    /* Length Of The Window Right Now, IN MINUTES */
    getLength = () => {

        /* Fields */
        const { start, end } = this.state

        /* Check Borders */
        if (!start || !end) {
            return 0
        }

        /* Send Result */
        return moment(end).diff(moment(start), "minutes")
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { operatorID, tableID, player, start, end, comment } = this.state
        const { reload } = this.props

        /* Check Operator */
        if (!operatorID) {
            Swal.fire(utils.notification(t("book.error.selectOperator"), "error"))
            return
        }

        /* Check Player */
        if (!String(player).trim()) {
            this._playerInput.error(t("book.error.emptyPlayer"))
            return
        }

        /* Check Game */
        if (!tableID) {
            Swal.fire(utils.notification(t("book.error.selectGame"), "error"))
            return
        }

        /* Check Borders */
        if (!start || !end) {
            Swal.fire(utils.notification(t("book.error.selectWindow"), "error"))
            return
        }

        /* Check Order */
        if (moment(end).diff(moment(start), "minutes") <= 0) {
            Swal.fire(utils.notification(t("book.error.wrongWindow"), "error"))
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Send to REST API */
        create({
            operatorID,
            tableID,
            player: String(player).trim(),
            start: wallToUtc(start),
            end: wallToUtc(end),
            comment: String(comment).trim(),
        }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("book.createdSuccess"), "success"))
                reload()
                this.close()
            }
            else {
                Swal.fire(utils.notification(this.message(response), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    /* Draw Operators — a reservation always belongs to exactly one operator */
    _operators = () => {

        /* Fields */
        const { operators, operatorID } = this.state

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <OperatorIcon />
                        {t("book.operator")}
                    </div>
                </div>

                {operators.length === 0
                    ? <div className="bkg--chips-empty">{t("book.noOperators")}</div>
                    : <div className="bkg--chips">
                        {operators.map((item, index) =>
                            <div
                                onClick={() => this.changeOperator(item.id)}
                                className={`bkg--chip round ${parseInt(operatorID) === parseInt(item.id) ? "active" : ""}`}
                                key={`${index}`}
                            >
                                <div className="bkg--chip-mark"><CheckIcon size={11} /></div>
                                <div className="bkg--chip-text">
                                    <div className="bkg--chip-name">{item.name}</div>
                                    {item.slug ? <div className="bkg--chip-slug">{item.slug}</div> : null}
                                </div>
                            </div>
                        )}
                    </div>
                }

            </div>
        )
    }

    /* Draw Player — the id is the only thing the operator really knows the player by */
    _player = () => {

        /* Fields */
        const { player, found, checking } = this.state

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <PlayerIcon />
                        {t("book.player")}
                    </div>
                </div>

                <Input
                    label={t("book.playerID")}
                    value={player}
                    onChange={(event) => this.changePlayer(event.target.value)}
                    ref={(ref) => this._playerInput = ref}
                />

                {/* Checking */}
                {checking && <div className="bkg--player-note">{t("book.checkingPlayer")}</div>}

                {/* Found */}
                {!checking && found && found.found &&
                    <div className="bkg--player-card">

                        <div className="bkg--player-name">
                            {utils.checkValue(found.firstName, t("book.noName"))}
                            {found.isVip && <span className="bkg--tag vip"><VipIcon size={10} /> VIP</span>}
                            {found.isTester && <span className="bkg--tag tester">{t("book.tester")}</span>}
                        </div>

                        <div className="bkg--player-meta">
                            <span>{found.player}</span>
                            {found.currency ? <span>{String(found.currency).toUpperCase()}</span> : null}
                        </div>

                    </div>
                }

                {/* Unknown — the reservation is still written, the warning only asks to read the id once more */}
                {!checking && found && !found.found &&
                    <div className="bkg--warning">
                        <InfoIcon size={14} />
                        <span>{t("book.unknownPlayer")}</span>
                    </div>
                }

            </div>
        )
    }

    /* Draw Games — only the VIP games of the selected operator */
    _tables = () => {

        /* Fields */
        const { tables, tableID, operatorID, search } = this.state
        const list = this.getTables()

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <TableIcon />
                        {t("book.game")}
                    </div>
                </div>

                {/* Operator First — the list of games depends on it */}
                {!operatorID &&
                    <div className="bkg--hint">
                        <InfoIcon size={14} />
                        <span>{t("book.selectOperatorFirst")}</span>
                    </div>
                }

                {operatorID > 0 && tables.length > SEARCHABLE &&
                    <div className="bkg--inner-search">
                        <span className="bkg--inner-search-icon"><TableIcon size={13} /></span>
                        <input value={search} onChange={(event) => this.setState({ search: event.target.value })} placeholder={t("book.searchByGame")} />
                        {search !== "" &&
                            <div onClick={() => this.setState({ search: "" })} className="bkg--inner-search-clear">
                                <CloseIcon size={11} />
                            </div>
                        }
                    </div>
                }

                {operatorID > 0 && list.length === 0 &&
                    <div className="bkg--chips-empty">{search !== "" ? t("book.nothingFound") : t("book.noGames")}</div>
                }

                {operatorID > 0 && list.length > 0 &&
                    <div className="bkg--chips">
                        {list.map((item, index) =>
                            <div
                                onClick={() => this.setState({ tableID: parseInt(item.id) })}
                                className={`bkg--chip ${parseInt(tableID) === parseInt(item.id) ? "active" : ""}`}
                                key={`${index}`}
                            >
                                <div className="bkg--chip-mark"><CheckIcon size={11} /></div>
                                <div className="bkg--chip-text">
                                    <div className="bkg--chip-name">{item.name}</div>
                                    <div className="bkg--chip-slug">{utils.checkValue(item.studioName, item.slug)}</div>
                                </div>
                            </div>
                        )}
                    </div>
                }

            </div>
        )
    }

    /* Draw Window — the borders are read in the timezone of the panel, the label says which one it is */
    _window = () => {

        /* Fields */
        const { start, end } = this.state
        const length = this.getLength()

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <ClockIcon />
                        {t("book.window")}
                    </div>
                    <div className="bkg--section-note">{offsetLabel(currentOffsetHours())}</div>
                </div>

                <div className="bkg--range">

                    <DatePicker
                        selected={start}
                        onChange={(date) => this.changeStart(date)}
                        selectsStart
                        startDate={start}
                        endDate={end}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        timeIntervals={STEP}
                        placeholderText={t("book.from")}
                    />

                    <DatePicker
                        selected={end}
                        onChange={(date) => this.setState({ end: date })}
                        selectsEnd
                        startDate={start}
                        endDate={end}
                        minDate={start}
                        dateFormat="dd.MM.yyyy HH:mm"
                        locale="ru"
                        showTimeSelect
                        timeIntervals={STEP}
                        placeholderText={t("book.to")}
                    />

                </div>

                {/* Ready Made Lengths */}
                <div className="bkg--chips small">
                    {LENGTHS.map((item, index) =>
                        <div
                            onClick={() => this.setLength(item)}
                            className={`bkg--length ${length === item ? "active" : ""}`}
                            key={`${index}`}
                        >
                            {item < 60 ? `${item} ${t("book.unit.minutes")}` : `${item / 60} ${t("book.unit.hours")}`}
                        </div>
                    )}
                </div>

                {/* Length */}
                {length > 0 &&
                    <div className="bkg--hint">
                        <CalendarIcon size={14} />
                        <span>{t("book.lengthHint")} {length < 60 ? `${length} ${t("book.unit.minutes")}` : `${Math.floor(length / 60)} ${t("book.unit.hours")}${length % 60 > 0 ? ` ${length % 60} ${t("book.unit.minutes")}` : ""}`}</span>
                    </div>
                }

            </div>
        )
    }

    /* Draw Comment — why the table is held, the pitboss of the next shift reads it */
    _comment = () => {

        /* Fields */
        const { comment } = this.state

        return (
            <div className="bkg--section">

                <div className="bkg--section-head">
                    <div className="bkg--section-title">
                        <CommentIcon />
                        {t("book.comment")}
                    </div>
                </div>

                <textarea
                    value={comment}
                    onChange={(event) => this.setState({ comment: event.target.value })}
                    className="bkg--textarea"
                    placeholder={t("book.commentPlaceholder")}
                    rows={3}
                />

            </div>
        )
    }

    /* Draw Body */
    _body = () => {

        /* Fields */
        const { status } = this.state

        /* Check Status */
        if (status === "loading") {
            return <div className="bkg--modal-loading"><div className="bkg--loading" /></div>
        }

        return (
            <div className="bkg--modal-body">

                {/* Draw Operators */}
                {this._operators()}

                {/* Draw Player */}
                {this._player()}

                {/* Draw Games */}
                {this._tables()}

                {/* Draw Window */}
                {this._window()}

                {/* Draw Comment */}
                {this._comment()}

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, waiting, status } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="bkg--modal"
                overlayClassName="bkg--overlay"
                closeTimeoutMS={200}
            >

                <div className="bkg--modal-header">

                    <div className="bkg--modal-icon">
                        <PlusIcon size={18} />
                    </div>

                    <div className="bkg--modal-head-text">
                        <h2>{t("book.createTitle")}</h2>
                        <p>{t("book.createSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="bkg--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                {/* Draw Body */}
                {this._body()}

                <div className="bkg--modal-footer">

                    <div onClick={() => this.close()} className="bkg--button ghost">{t("common.cancel")}</div>

                    {waiting
                        ? <div className="bkg--button primary"><div className="bkg--loading small" /></div>
                        : <div onClick={() => status === "ok" && this.save()} className={`bkg--button primary ${status === "ok" ? "" : "disabled"}`}>{t("book.createButton")}</div>
                    }

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
    timezone: state.timezone,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(BookingForm)
